!function($) {

  // Add custom JavasScript here
  // --------------------------



  // Document ready
  $(function() {
    if ($(window).width() >768 ){
    $(".header-searchs").click(function(){
       $(".hide-inpcform").fadeToggle();
    });
    
     $("body").bind("click",function(evt){ 
  if($(evt.target).closest(".header-searchs").length==0&&$(evt.target).closest(".menu-icon-search-form").length==0)
  { 
   $(".hide-inpcform").hide();
  } 
}); 
    }  
    
//     $("#app-header #app-lower-header .menu ul.level-1 li.level-1").hover(function(){
//      $(this).find(".white-bgccolor").height($(this).find(".submenu-ho").innerHeight()).css({"opacity":"1","visibility":"visible","transform":"translateY(0)"});
//     },function(){
//       $(this).find(".white-bgccolor").css({"opacity":"0","visibility":"hidden","transform":"translateY(-20px)"});
//     });
    $(".white-bgccolor02").each(function(){
//       var parentleft = $(this).parent().offset.left;
//         console.log( $(this).parent(".submenu-ho").offset().left);
      $(this).css("left",-$(this).parent(".submenu-ho").offset().left);
    
    
    });
    
    $(window).scroll(function(){
      
         $("#app-header #app-lower-header .menu ul.level-1 li.level-1").find(".white-bgccolor").css({"opacity":"0","visibility":"hidden","transform":"translateY(-20px)"});

 
    });
    
        $(window).scroll(function(){
          if( $(window).width() > 768 ){
      
       if ($(this).scrollTop() > 140) {  
         let AllTopHeight=$('#app-upper-header').height()+$('#announcement-bar').height();
         $('#app-lower-header').css({"position":"fixed",top:`${AllTopHeight}px` }).addClass("over-headers");    
         $('#site-nav .level-1-all-product-level').removeClass('sticky-index');

   } else {    
    $('#app-lower-header').css({"position":"relative",top:`0px`}).removeClass("over-headers");
       $('#site-nav .level-1-all-product-level').addClass('sticky-index');
   }  
            
    
            
            
}else{
                   if ($(this).scrollTop() > 140) {      
    $('#app-upper-header').css({"position":"fixed",top:"0px" }).addClass("over-headers");    

   } else {    
    $('#app-upper-header').css({"position":"relative"}).removeClass("over-headers");
      
   }  
              
              
              
            } 
 });
    
          var winheights =  $(window).height();
        $(window).scroll(function(){
          if($(".desc-item-desc").offset()){
      if(winheights + $(window).scrollTop()-70 > $(".desc-item-desc").offset().top){
    $(".pro_nav-features").addClass("active");
         $(".pro_nav-features").siblings().removeClass("active");
      }
          }
          if($(".desc-item-specs").offset()){
     if(winheights + $(window).scrollTop()-50 > $(".desc-item-specs").offset().top){
    $(".pro_nav-specs").addClass("active");
         $(".pro_nav-specs").siblings().removeClass("active");
      }
          }
              if($(".desc-item-reviews").offset()){
            if(winheights + $(window).scrollTop()-50 > $(".desc-item-reviews").offset().top){
           $(".pro_nav-reviews").addClass("active");
         $(".pro_nav-reviews").siblings().removeClass("active");
      }
   
              }
        if($(".desc-item-downloads").offset()){
            if(winheights + $(window).scrollTop()-50 > $(".desc-item-downloads").offset().top){
    $(".pro_nav-download").addClass("active");
         $(".pro_nav-download").siblings().removeClass("active");
      }

        }
          
           if($(".desc-item-package").offset()){
            if(winheights + $(window).scrollTop()-50 > $(".desc-item-package").offset().top){
    $(".pro_nav-package-contents").addClass("active");
         $(".pro_nav-package-contents").siblings().removeClass("active");
      }

        }
    });
    
        $(".pro_nav-features").click(function(){
   
          $('html,body').animate({
        scrollTop: $(".desc-item-desc").offset().top-50 + "px"
    }, 300);
      
       
    });
    
            $(".pro_nav-specs").click(function(){
   
          $('html,body').animate({
        scrollTop: $(".desc-item-specs").offset().top-70 + "px"
    }, 300);
      
       
    });
    
                $(".pro_nav-reviews").click(function(){
   
          $('html,body').animate({
        scrollTop: $(".desc-item-reviews").offset().top-70 + "px"
    }, 300);
      
       
    });
    
        
                $(".pro_nav-download").click(function(){
   
          $('html,body').animate({
        scrollTop: $(".desc-item-downloads").offset().top-70 + "px"
    }, 300);
      
       
    });
          $(".pro_nav-package-contents").click(function(){
   
          $('html,body').animate({
        scrollTop: $(".desc-item-package").offset().top-70 + "px"
    }, 300);
      
       
    });


    
    $(".des_playbotton").click(function(){
      
      console.log("4");
     $(".original-video").trigger('pause');
      $(".bg-outovervideo").show();
        $(".over-video").trigger('play');
    });
        $(".delete-x-ho").click(function(){
     $(".original-video").trigger('play');
      $(".bg-outovervideo").hide();
        $(".over-video").trigger('pause');
    });   
         
         

     
    $(".nextwinner-item-wrapper:even").css("background","#F1F1F1");
    $(".showmorewinner").click(function(){
         $(this).hide();
     $(this).nextAll().show();
    
    });
         $(".hideshows").click(function(){
     $(".showmorewinner").nextAll().hide();
           
   $(".showmorewinner").show();
    });
    
             $(".submit-giwaway").click(function(){
//                console.log("click");
//                 console.log( $('#checks_subscribe').is(':checked') );
//                 console.log( $('#checks_subscribe').prop('checked') );
   if($('#checks_subscribe').is(':checked')){
     return true;
   }else{
 alert("Please check the box above the button first");
             return false;
    
   }
 
    });
    
         $(".luckimg-btn,.luckimg02").click(function(){
     $(".pagegiveaway-overboxs").hide();
        window.location.href="https://marvopro.com/pages/giveaway";   

    });
//              $(".collapsible-ho").click(function(e){
// //                e.preventDefault();
               
//                          if($(this).children('ul').is(':hidden')){
//                       $(this).addClass("top-arraws");
//                       }else{
//                         $(this).removeClass("top-arraws");
//                       }
//                		$(this).children('ul').stop().slideToggle(300);
//                });  
   $("#slide-side-menu .menu ul.level-1 li.level-1>a").attr("disabled",true).css("pointer-events","none"); 
   $("li[id$='black-friday']>a").attr("disabled",false).css("pointer-events","auto"); 
         var mswiperrecommend = new Swiper ('.swiper-container-recommend', {
      slidesPerView : 5,  
    navigation: {
      nextEl: '.swiper-button-next-recommend',
      prevEl: '.swiper-button-prev-recommend',
    },

  });


//     if(location.href == 'https://marvopro.com/pages/giveaway' || location.href == 'https://marvopro.com/pages/affiliate-program' || location.href == 'https://marvopro.com/pages/not_found'){

//     }else{

//         location.href="https://marvopro.com/pages/not_found";

//     }
    $(".blogs-box-item-title").click(function(){
       $(this).addClass("active").siblings().removeClass("active")
    });
       $(".blogs-box-item-titleall").click(function(){
       $(".blogs-box-item-all").show().siblings().hide();
    });
           $(".blogs-box-item-titlenews").click(function(){
       $(".blogs-box-item-news").show().siblings().hide();
    }); 
               $(".blogs-box-item-titleproducts").click(function(){
       $(".blogs-box-item-products").show().siblings().hide();
    }); 
               $(".blogs-box-item-titlegame").click(function(){
       $(".blogs-box-item-game").show().siblings().hide();
    }); 
    
         $("body").bind("click",function(evt){ 
  if($(evt.target).closest(".tanchuangcenter_box").length==0)
  { 
   $(".tanchuang-overboxs").hide();
  } 
   
}); 
    
      $(".tanchuangx02").click(function(){
        $(".tanchuang-overboxs").hide();
    });    
    
     $(".clo-imagenav-wrapper img").height($(".level-2.clean-list").height());
     
  });
  
  

 let el={
  siteNavEL:'#site-nav',
  siteNavItemEL:'#site-nav li.level-1',
  siteNavItem2EL:'#site-nav li.level-2',
  mbSlideDrawer:'.mb-slide-drawer'
}
// stie nav
$(el.siteNavItemEL).hover(function(){
	$(this).find('.level-2-ul').stop(false,true).show();
},function(){
 	$(this).find('.level-2-ul').stop(false,true).hide();
})
$(el.siteNavItem2EL).hover(function(){
	$(this).find('.level-3-ul').stop(false,true).show();
},function(){
 	$(this).find('.level-3-ul').stop(false,true).hide();
})
  

// feature-collection-list swiper

 var fclcSwiper = new Swiper('.fclc-content .swiper-box-inner', {
	autoplay: true,
    loop : true,
    autoplay: {
    delay: 5000,
  },
   pagination: {
    el: '.swiper-pagination',
     clickable :true,
  },
})
 $(document).ready(function(){
 	let newsletterHeight=0;
   if($(window).width()>768){
      newsletterHeight=$('.newsletter-content').outerHeight()/2;
  
      }
 else{
 	 newsletterHeight=$('.newsletter-content').outerHeight()/3;
 }
   $('.newsletter-content-newsletter').css('margin-bottom',`-${newsletterHeight}px`);
   $('#footer-content').css('padding-top',`${newsletterHeight}px`);
 })
  

 
// recommendations

  var fclcSwiper = new Swiper('.fclc-content .swiper-box-inner', {
	autoplay: true,
    loop : true,
    autoplay: {
    delay: 5000,
  },
   pagination: {
    el: '.swiper-pagination',
     clickable :true,
  },
})

 
 
 
 
}(jQuery);

